// Lib
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Utils
import { isRealUserId } from '../../../common/users/userHelper';
import { getRootType } from '../../../common/elements/utils/elementPropertyUtils';
import { getUserId } from '../../../common/users/utils/userPropertyUtils';

// Selectors
import { getCurrentUser, getCurrentUserQuickNotesRootBoardId } from '../../user/currentUserSelector';
import { getCurrentBoard } from '../../element/selectors/currentBoardSelector';

// Actions
import { fetchBoard } from '../../element/board/boardService';

// Constants
import { RootBoardTypes } from '../../../common/boards/boardConstants';

/**
 * Pre-fetches the quick notes board on mount.
 */
const useFetchQuickNotesOnMount = () => {
    const dispatch = useDispatch();

    const currentBoard = useSelector(getCurrentBoard);
    const currentUser = useSelector(getCurrentUser);
    const quickNotesBoardId = useSelector(getCurrentUserQuickNotesRootBoardId);

    const currentUserId = getUserId(currentUser);

    useEffect(() => {
        if (!currentUserId) return;

        if (!isRealUserId(currentUserId)) return;

        // Pre-fetch the quick notes board if the current board is not the quick notes board
        const isCurrentBoardQuickNotes = getRootType(currentBoard) === RootBoardTypes.QUICK_NOTES;
        if (!isCurrentBoardQuickNotes) {
            dispatch(
                fetchBoard({
                    boardId: quickNotesBoardId,
                    excludeSelf: false,
                    loadAncestors: false,
                }),
            );
        }
    }, [currentUserId]);
};

export default useFetchQuickNotesOnMount;
